
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/map-testing",
      function () {
        return require("private-next-pages/map-testing.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/map-testing"])
      });
    }
  